import React from 'react';
import { ExternalLink } from 'lucide-react';
import { REL_AMAZON, linkAmazonDireto, registrarCliqueAmazon } from '../utils/amazonSitestripe';

/**
 * Botão de compra da oferta Amazon manual (SiteStripe) na página da oferta: <a href> DIRETO para o link oficial.
 * Sem /api/go/deal, sem /r/, sem redirect. O clique é contado por beacon e a navegação segue sozinha; sem JS o link
 * funciona igual. Link fora do formato oficial = sem CTA de compra.
 */
export default function AmazonManualCta({ deal, className = '' }) {
    const link = linkAmazonDireto(deal);
    if (!link) {
        return (
            <div className="flex items-center justify-center gap-2 w-full py-4 rounded-lg text-lg font-semibold cursor-not-allowed"
                style={{ background: 'var(--surface-2)', border: '1px solid var(--border)', color: 'var(--muted)' }}
                data-testid="buy-unavailable">
                Oferta indisponível
            </div>
        );
    }
    return (
        <a href={link} target="_blank" rel={REL_AMAZON} onClick={() => registrarCliqueAmazon(deal.deal_id, 'deal_page')}
            className={className} data-testid="buy-btn-amazon">
            Ver oferta na Amazon
            <ExternalLink className="w-5 h-5" />
        </a>
    );
}
